export default __webpack_public_path__ + "static/media/e-a_demo.ac34a3a4.gif";